import { Component, OnInit, OnDestroy } from '@angular/core';
import { ContractService } from '../../../../services/contract.service';
import { Contract } from '../../../../models/Contract';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataService } from '../../../../services/data.service';
import { Contact } from '../../../../models/Contact';


@Component({
  selector: 'app-search-contracts',
  templateUrl: './search-contracts.component.html',
  styleUrls: ['./search-contracts.component.scss']
})
export class SearchContractsComponent implements OnInit, OnDestroy {

  public ContractsPerPage = [
    { id: 0, value: 5 },
    { id: 1, value: 10 },
    { id: 2, value: 20 }
  ];
  public selectedPerPageId = 0;
  public searchText: string;
  public contracts: Contract[];
  public sortBy = 'InvoiceBalance';
  public sortOrder = 'asc';
  public contractPg = 1;
  private alive = true;

  constructor(private contractService: ContractService,
    private router: Router,
    public datasvc: DataService,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    if (this.contractService.searchText) {
      this.searchText = this.contractService.searchText;
    }

    if (this.contractService.contracts && this.contractService.contracts.length > 0) {
      this.contracts = this.contractService.contracts;
    } else if (this.searchText) {
      this.searchContracts();
    }
  }

  searchContracts() {
    this.spinner.show();
    this.contractService.setSearchText(this.searchText);
    this.contractService.searchContract()
      .takeWhile(() => this.alive)
      .subscribe(
        data => {

          this.contracts = data;

         // this.datasvc.userDisplayInfo.id = this.contracts[0].AdminGuid;
        //  this.datasvc.userDisplayInfo.bearerToken = this.contracts[0].bearerToken;
          console.log(this.contracts);
          console.log( this.datasvc.userDisplayInfo.id);
          this.spinner.hide();
        },
        err => {
          console.log('Search test, ', err);
          this.spinner.hide();
        }
      );
  }

  btnContractClick(card: any, $event: Event) {
    this.router.navigate([`/pages/client/my-contracts/contract/${card.ContractNumber}/overview`]);
  }

  public btnSubmitHoursClick(card: any, $event: Event) {

    $event.stopPropagation();
    this.router.navigateByUrl(`/pages/client/my-contracts/contract/${card.ContractNumber}/flight-hours?submithours=true`);
  }

  public btnPayInvoicesClick(card: any, $event: Event) {
    $event.stopPropagation();
    this.router.navigateByUrl(`/pages/client/my-contracts/contract/${card.ContractNumber}/financials?payInvoices=true`);
  }

  ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/client/my-contracts/search-contracts/search-contracts.component.ts